<template>
    <rkm-overlay>
        <rkm-layout-body title="Visita domiciliar">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="handleEditPaciente"
                    authorize="update-cadastro-paciente"
                    color="info"
                >
                    Editar cadastro do paciente
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="parseInt($route.params.id)"
                    :pacienteId="parseInt($route.params.pacienteId)"
                    :visitasRealizadas="$route.params.visitasRealizadas"
                    @loaded="loaded"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import Form from "@/components/atencao-basica/visita-domiciliar/Form";
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Vuex.
import { mapActions } from 'vuex';

// Mixins
import { repository, error, object, data, unmask } from '@/mixins'

export default {
    components: {
        Form,
        ModalIntegracaoCns,
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.model && this.model.cidadao.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.model && this.model.cidadao.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.model && this.model.cidadao.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    created() {

        this.setShowExitFormConfirmation()

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.atencaoBasica')
        }
    },
    data: () => ({
        additionals: null,
        cadastro: false,
        enums: {classificacao},
        model: null,
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
        ]),
        loaded(value) {
            this.additionals = value.additionals
            this.model = value.model
        },
        handleExit() {
            this.$router.push({ name: 'atencao-basica-visita-domiciliar-list', params: { id: this.$route.params.pacienteId } })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        handleEditPaciente() {
            if (!this.model || !this.model.cidadao.pacienteId) {
                return
            }

            this.$router.push({ name: 'cadastro-paciente-edit', params: { id: this.model.cidadao.pacienteId } })
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.model.cidadao.cidadaoId,
                nome: this.model.cidadao.nome,
                dataNascimento: this.model.cidadao.dataNascimento,
                nomeMae: this.model.cidadao.nomeMae,
                cns: this.model.cidadao.cns ? this.unMaskCns(this.model.cidadao.cns) : null,
                cpf: this.model.cidadao.cpf ? this.unMaskCpf(this.model.cidadao.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.model.cidadao, {
                ...item,
                sexoId: item.sexo.id,
                sexo: item.sexo.descricao,
                idade: item.idadeFormatada,
            })
        },
    },
    mixins: [repository, error, object, data, unmask],
}
</script>